import { render } from "./CreatePerson.vue?vue&type=template&id=8eee0dbe"
import script from "./CreatePerson.vue?vue&type=script&lang=js"
export * from "./CreatePerson.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__